/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
  createDialogRoute, DictionaryService, EnumDictionary,
  FormState,
  FormStateBuilder,
} from '@gh/common-shared';
import {
  DialogInput, NotificationService,
} from '@gh/core-ui';
import { HlpDetails, HlpRestService, ListingStatus } from '@gh/builder-shared-data';

export interface HlpUpdateListingStatusDialogConfig {
  hlp: HlpDetails;
}

@Component({
  selector:    'gh-hlp-update-listing-status-dialog',
  template: require('./hlp-update-listing-status-dialog.component.html'),
  styles:   [require('./hlp-update-listing-status-dialog.component.scss')],
})
export class HlpUpdateListingStatusDialogComponent implements OnInit, DialogInput<HlpUpdateListingStatusDialogConfig> {
  input: HlpUpdateListingStatusDialogConfig;
  form: FormState<any>;
  listingStatuses: EnumDictionary<ListingStatus>;

  constructor(
    private dialogRef: MatDialogRef<any>,
    private formStateBuilder: FormStateBuilder,
    private notificationService: NotificationService,
    private hlpRest: HlpRestService,
    private dictionaryService: DictionaryService,
    ) {

  }

  ngOnInit(): void {
    this.form = this.formStateBuilder.buildPlain({
      value:    {
        listingStatus:     '',
      },
      children: {
        listingStatus:     { required: true },
      },
    });
    this.dictionaryService.getByEnum(ListingStatus).subscribe((statuses) => {
      this.listingStatuses = statuses;
    });
  }

  onSkip(): void {
    this.dialogRef.close({continueDeleting: true});
  }

  onUpdate(): void {
        this.dialogRef.close({
          continueDeleting: true,
          listingStatus: this.form.get('listingStatus').value,
        });
  }

  onCancel(): void {
    this.dialogRef.close({continueDeleting: false});
  }
}

export const hlpUpdateListingStatusDialogRoute = createDialogRoute({
  component: HlpUpdateListingStatusDialogComponent,
});
